import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../../utils/types";
import {
  selectUserLoading,
  selectUserPoints,
} from "../../../../../redux/educator/selector";
import { getUserPoints } from "../../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  userPoints: selectUserPoints(state),
  userPointsLoading: selectUserLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUserPoints,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
